import React, { useState, useEffect } from 'react';
import api from '../config/axios';
import Menu from '../components/menu';
import Footer from '../components/footer';
import ImgBannerPartenaire from '../components/imgBannerPartenaire';
import UserCard from '../components/cardPlayer'; // Assurez-vous que le chemin est correct

interface TUser {
    userId: number;
    nom: string;
    prenom: string;
    classement: number
    civiliteId: number;
    handId: number;
    departementId: number;
    niveauId: number;
    dispoTournoi: boolean;
    dispoLibre: boolean;
}

interface TCivilite {
    civiliteId: number;
    civiliteLib: string;
}

interface THand {
    handId: number;
    handLib: string;
}

interface Filters {
    searchTerm: string;
    civiliteId: string;
    handId: string;
}

interface TDepartement {
    departementId: number;
    departementNum: string;
    departementLib: string;
}

interface TNiveau {
    niveauId: number;    
    niveauLib: string;
    niveauOrdre: number;
    niveauDescription: string;
}

interface TDisponibilite {
    id: number;
    jour: string;
    heureDebut: string;
    heureFin: string;
    user: TUser;
  }

const PartenairesConnected: React.FC = () => {

    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [users, setUsers] = useState<TUser[]>([]);
    const [filteredUsers, setFilteredUsers] = useState<TUser[]>([]);
    const [civilites, setCivilites] = useState<TCivilite[]>([]);
    const [hands, setHands] = useState<THand[]>([]);
    const [deps, setDepartement] = useState<TDepartement[]>([]);
    const [niveau, setNiveau] = useState<TNiveau[]>([]);
    const [disponibilites, setDisponibilites] = useState<TDisponibilite[]>([]);
    const [userDisponibilites, setUserDisponibilites] = useState<{[key: number]: TDisponibilite[]}>({});

    const [filters, setFilters] = useState({
        searchTerm: '',
        handId: '',
        civiliteId: '',
        departementId: '',
        niveauId: '',
        classementMin: '',
        classementMax: '',
        dispoTournoi: false,
        dispoLibre: false,
        jourDispo: '',
        heureDebutDispo: '',
        heureFinDispo: '',
    });


  // Ajouter cet useEffect pour charger les disponibilités des utilisateurs
  useEffect(() => {
    const fetchDisponibilites = async () => {
      try {
        const response = await api.get('/disponibilite/all');
        const dispos = response.data;
        
        // Organiser les disponibilités par utilisateur
        const userDispos: {[key: number]: TDisponibilite[]} = {};
        dispos.forEach((dispo: TDisponibilite) => {
          if (!userDispos[dispo.user.userId]) {
            userDispos[dispo.user.userId] = [];
          }
          userDispos[dispo.user.userId].push(dispo);
        });
        
        setUserDisponibilites(userDispos);
        setDisponibilites(dispos);

      } catch (error) {
        console.error('Error fetching disponibilités:', error);
      }
    };
    
    fetchDisponibilites();
  }, []);

    const filteredUser = users.filter(user => {

        const userHasMatchingDispo = () => {

            if (!filters.jourDispo) {  
                console.log("pas de filtres");              
              return true; // Pas de filtres de dispo appliqués
            }

            const userDispos = userDisponibilites[user.userId] || [];

            return userDispos.some(dispo => {
                // Filtrer par jour si spécifié
                if (filters.jourDispo && dispo.jour !== filters.jourDispo) {   
                    console.log("jourDispo: " + filters.jourDispo);                 
                  return false;
                }
                
                if (filters.jourDispo && dispo.jour == filters.jourDispo) {
                    console.log("jourDispo: " + filters.jourDispo);
                    // Filtrer par heure de début si spécifiée
                    if (filters.heureDebutDispo) {
                        const filterHeureDebut = filters.heureDebutDispo + ':00';
                        if (dispo.heureDebut >= filterHeureDebut) {
                            return false;
                        }
                    }
                    
                    // Filtrer par heure de fin si spécifiée
                    if (filters.heureFinDispo) {
                        const filterHeureFin = filters.heureFinDispo + ':00';
                        if (dispo.heureFin <= filterHeureFin) {
                            return false;
                        }
                    }

                    return true;

                }                
                
              });

        };

        return (
            (filters.searchTerm === '' || `${user.prenom} ${user.nom}`.toLowerCase().includes(filters.searchTerm.toLowerCase())) &&
            (filters.handId === '' || user.handId === parseInt(filters.handId)) &&
            (filters.civiliteId === '' || user.civiliteId === parseInt(filters.civiliteId)) &&
            (filters.departementId === '' || user.departementId === parseInt(filters.departementId)) &&
            (filters.niveauId === '' || user.niveauId === parseInt(filters.niveauId)) &&
            (filters.classementMin === '' || user.classement >= parseInt(filters.classementMin)) &&
            (filters.classementMax === '' || user.classement <= parseInt(filters.classementMax)) &&
            (!filters.dispoTournoi || user.dispoTournoi) &&
            (!filters.dispoLibre || user.dispoLibre) &&
             // Nouveau filtre pour les disponibilités
            userHasMatchingDispo()
        );
    });

    const [currentPage, setCurrentPage] = useState(1);
    const usersPerPage = 12;

    const [currentUserId, setCurrentUserId] = useState<number | null>(null);
    
    useEffect(() => {
        const fetchCurrentUser = async () => {
            try {
                const response = await api.get('/users/me');
                setCurrentUserId(response.data.userId);
            } catch (error) {
                console.error('Error fetching current user:', error);
            }
        };
        fetchCurrentUser();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [usersRes, civilitesRes, handsRes, departementRes, niveauRes] = await Promise.all([
                    api.get('/users/canBeSearched'),
                    api.get('/civilite'),
                    api.get('/hand'),
                    api.get('/departement'),
                    api.get('/niveau')
                ]);

                // Filter out current user from the list
                const filteredUsers = usersRes.data.filter((user: { userId: any; }) => user.userId !== currentUserId);

                setUsers(filteredUsers);
                setFilteredUsers(usersRes.data);
                setCivilites(civilitesRes.data);
                setHands(handsRes.data);
                setDepartement(departementRes.data);
                setNiveau(niveauRes.data);

            } catch (error) {
                console.error("Erreur lors du chargement des données :", error);
            }
        };
        fetchData();
    }, [currentUserId]);

    const handleFilterChange = async (filterName: string, value: string | boolean) => {
        const newFilters = { ...filters, [filterName]: value };
        setFilters(newFilters);
        setCurrentPage(1);

        let filtered = users;
        
        if (newFilters.searchTerm) {
            const search = newFilters.searchTerm.toLowerCase();
            filtered = filtered.filter(user => 
                user.nom.toLowerCase().includes(search) || 
                user.prenom.toLowerCase().includes(search)
            );
        }
        
        if (newFilters.civiliteId) {
            filtered = filtered.filter(user => 
                user.civiliteId === parseInt(newFilters.civiliteId)
            );
        }
        
        if (newFilters.handId) {
            filtered = filtered.filter(user => 
                user.handId === parseInt(newFilters.handId)
            );
        }

        setFilteredUsers(filtered);
    };

    const [selectedUser, setSelectedUser] = useState<TUser | null>(null);
    const [messageContent, setMessageContent] = useState('');
    const [showMessageModal, setShowMessageModal] = useState(false);

    const handleSendMessage = async (receiverId: number) => {
        try {
            await api.post('/messages', {
                receiverId,
                content: messageContent
            });

            setShowMessageModal(false);
            setMessageContent('');
            
        } catch (error) {
            console.error('Error sending message:', error);
        }
    };

        const [subscriptionStatus, setSubscriptionStatus] = useState<{
            status: string;
            subscriptionValidUntil: string | null;
        }>({ status: '', subscriptionValidUntil: null });
        useEffect(() => {

        const fetchSubscriptionStatus = async () => {
          
          const response = await api.get('/account/subscription-status');
                    
          const data = response.data;

          setSubscriptionStatus(data);
        };
    
        fetchSubscriptionStatus();
      }, []);

    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = filteredUser.slice(indexOfFirstUser, indexOfLastUser);

    return (
        <div>            
            <div className="flex flex-col md:flex-row gap-6 p-4">
                {/* Sidebar Filters */}
                <div className="md:hidden p-4 mb-2">
                <button 
                    onClick={() => setIsFilterVisible(!isFilterVisible)}
                    className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white px-4 py-3 rounded-xl font-bold hover:from-orange-600 hover:to-orange-700 transition-all"
                >
                    {isFilterVisible ? '✕ Masquer les filtres' : '⊕ Afficher les filtres'}
                </button>
                </div>
                <div className={`
                    w-full md:w-1/4 bg-base-100 
                    ${isFilterVisible ? 'block' : 'hidden'} 
                    md:block
                    `}>
                    <div className="bg-white rounded-2xl shadow-lg p-4 sticky top-4">
                        <h3 className="text-lg font-semibold mb-4 text-gray-900">Recherche</h3>
                        <input
                            type="text"
                            placeholder="Rechercher un partenaire..."
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all outline-none mb-4"
                            onChange={(e) => handleFilterChange('searchTerm', e.target.value)}
                        />

                        <h3 className="text-lg font-semibold mb-4 text-gray-900">Genre</h3>
                        <select
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all outline-none mb-4"
                            onChange={(e) => handleFilterChange('civiliteId', e.target.value)}
                        >
                            <option value="">Toutes les genres</option>
                            {civilites.map(civilite => (
                                <option key={civilite.civiliteId} value={civilite.civiliteId}>
                                    {civilite.civiliteLib}
                                </option>
                            ))}
                        </select>

                        <h3 className="text-lg font-semibold mb-4 text-gray-900">Département</h3>
                        <select
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all outline-none mb-4"
                            onChange={(e) => handleFilterChange('departementId', e.target.value)}
                        >
                            <option value="">Tous les départements</option>
                            {deps.map(departement => (
                                <option key={departement.departementId} value={departement.departementId}>
                                    {departement.departementNum} - {departement.departementLib}
                                </option>
                            ))}
                        </select>
                        <h3 className="text-lg font-semibold mb-4 text-gray-900">Placement préférentiel</h3>
                        <select
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all outline-none mb-4"
                            onChange={(e) => handleFilterChange('handId', e.target.value)}
                        >
                            <option value="">Toutes les placements</option>
                            {hands.map(hand => (
                                <option key={hand.handId} value={hand.handId}>
                                    {hand.handLib}
                                </option>
                            ))}
                        </select>

                        <h3 className="text-lg font-semibold mb-4 text-gray-900">Niveau</h3>
                        <select
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all outline-none mb-4"
                            onChange={(e) => handleFilterChange('niveauId', e.target.value)}
                        >
                            <option value="">Tous les niveaux</option>
                            {niveau.map(niveau => (
                                <option key={niveau.niveauId} value={niveau.niveauId}>
                                    {niveau.niveauOrdre} - {niveau.niveauLib}
                                </option>
                            ))}
                        </select>

                        <h3 className="text-lg font-semibold mb-4 text-gray-900">Classement</h3>
                        <div className="flex space-x-2 mb-4">
                            <input
                                type="number"
                                placeholder="Min"
                                className="w-1/2 px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all outline-none"
                                onChange={(e) => handleFilterChange('classementMin', e.target.value)}
                            />
                            <input
                                type="number"
                                placeholder="Max"
                                className="w-1/2 px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all outline-none"
                                onChange={(e) => handleFilterChange('classementMax', e.target.value)}
                            />
                        </div>

                        <label className="flex items-center space-x-2 mb-4 p-3 bg-orange-50 rounded-xl border border-orange-200">
                            <input
                                type="checkbox"
                                onChange={(e) => handleFilterChange('dispoTournoi', e.target.checked)}
                                className="checkbox checkbox-warning"
                            />
                            <span className="text-sm font-medium text-orange-900">Dispo tournois</span>
                        </label>

                        <label className="flex items-center space-x-2 mb-4 p-3 bg-orange-50 rounded-xl border border-orange-200">
                            <input
                                type="checkbox"
                                onChange={(e) => handleFilterChange('dispoLibre', e.target.checked)}
                                className="checkbox checkbox-warning"
                            />
                            <span className="text-sm font-medium text-orange-900">Dispo jeu libre</span>
                        </label>
                        
                        <h4 className="text-lg font-semibold mb-4 text-gray-900">Disponibilités</h4>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">Jour</label>
                            <select
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all outline-none"
                            onChange={(e) => handleFilterChange('jourDispo', e.target.value)}
                            >
                            <option value="">Tous les jours</option>
                            <option value="Lundi">Lundi</option>
                            <option value="Mardi">Mardi</option>
                            <option value="Mercredi">Mercredi</option>
                            <option value="Jeudi">Jeudi</option>
                            <option value="Vendredi">Vendredi</option>
                            <option value="Samedi">Samedi</option>
                            <option value="Dimanche">Dimanche</option>
                            </select>
                        </div>
                        
                        <div className="grid grid-cols-2 gap-2">
                            <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">À partir de</label>
                            <input
                                type="time"
                                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all outline-none"
                                onChange={(e) => handleFilterChange('heureDebutDispo', e.target.value)}
                            />
                            </div>
                            <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">Jusqu'à</label>
                            <input
                                type="time"
                                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all outline-none"
                                onChange={(e) => handleFilterChange('heureFinDispo', e.target.value)}
                            />
                            </div>
                        </div>

                    </div>
                </div>

                {/* Users Grid */}
                <div className="w-full md:w-3/4 lg:w-4/5">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                        {currentUsers.map((user) => (
                            <UserCard
                                key={user.userId}
                                userId={user.userId}
                                prenom={user.prenom}
                                nom={user.nom}
                                genre={civilites.find(c => c.civiliteId === user.civiliteId)?.civiliteLib || ''}
                                main={hands.find(h => h.handId === user.handId)?.handLib || ''}
                                departement={deps.find(h => h.departementId === user.departementId)?.departementNum + ' - ' + deps.find(h => h.departementId === user.departementId)?.departementLib || ''}
                                niveau= {niveau.find(h => h.niveauId === user.niveauId)?.niveauOrdre + ' - ' +  niveau.find(h => h.niveauId === user.niveauId)?.niveauLib || ''}
                                classement={user.classement}
                                dispoJeu= {user.dispoLibre?'Oui':'Non'}
                                dispoTournoi={user.dispoTournoi?'Oui':'Non'}
                                onMessageClick={() => {
                                    setSelectedUser(user);
                                    setShowMessageModal(true);
                                }}
                            />
                        ))}
                    </div>
                    {showMessageModal && selectedUser && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white p-6 rounded-lg w-96">
                            <h3 className="text-lg font-bold mb-4">
                                Message à {selectedUser.prenom} {selectedUser.nom}
                            </h3>
                            <textarea
                                value={messageContent}
                                onChange={(e) => setMessageContent(e.target.value)}
                                className="w-full h-32 border rounded p-2 mb-4"
                                placeholder="Votre message..."
                            />
                            <div className="flex justify-end space-x-2">
                                <button
                                    onClick={() => {
                                        setShowMessageModal(false);
                                        setMessageContent('');
                                    }}
                                    className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
                                >
                                    Annuler
                                </button>
                                <button
                                    onClick={() => handleSendMessage(selectedUser.userId)}
                                    className="px-4 py-2 bg-orange-300 text-white rounded hover:bg-orange-400"
                                >
                                    Envoyer
                                </button>
                            </div>
                        </div>
                    </div>
                    )}
                    {/* Pagination */}
                    <div className="mt-12 flex justify-center gap-4">
                        <button
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            className="px-6 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                        >
                            ← Précédent
                        </button>
                        <span className="px-6 py-3 text-gray-700 font-semibold">
                            Page {currentPage} sur {Math.ceil(filteredUser.length / usersPerPage) || 1}
                        </span>
                        <button
                            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(filteredUser.length / usersPerPage)))}
                            disabled={indexOfLastUser >= filteredUser.length}
                            className="px-6 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:from-orange-600 hover:to-orange-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                        >
                            Suivant →
                        </button>
                    </div>
                </div>
            </div>                                
        </div>
    );
};

export default PartenairesConnected;